
import React from 'react'
import {arabicImage ,englishImage} from '../../assets/Images'
import { useStateContext } from "../../context/ContextProvider";
function ToggleLanguages() {
  
const {currentDir,currentLang,setLang,setDir } = useStateContext();
const themLangHandeler= () =>{
  
if (currentDir === 'rtl'){
setDir('ltr')
}
else if (currentDir === 'ltr'){
setDir('rtl')}
;}
return (<>
<div
  onClick={themLangHandeler}
  className="w-11 h-11 flex p-1 justify-center overflow-hidden items-center text-gray-900 bg-white border border-gray-300 outline-none hover:bg-gray-100 bg-opacity-50 dark:bg-opacity-50 ring-4 ring-gray-200 font-medium rounded-lg 800px:text-md text-sm  dark:bg-color-2 dark:text-white dark:hover:bg-gray-700 dark:border-gray-600 dark:ring-gray-700"
>
  {currentDir === 'rtl' ? (
    <img
      src={arabicImage}
      alt="Arabic"
      className="w-full  object-cover rounded-md h-full"
    />
  ) : (
    <img
      src={englishImage}
      alt="English"
      className="w-full  object-cover  rounded-md h-full"
    />
  )}
 
</div>
</>                                                                                             
)}
export default ToggleLanguages
